import React, { FC } from 'react';


const OfflinePage: FC = () => {
  return (
    <>
    </>
  );
};

export default OfflinePage;
